import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Page from './views/Page.vue';
import BuyNow from './views/BuyNow.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',

  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/:year(1997|1998|2001|2004|2010|2011|2018)',
      name: 'page',
      component: Page,
    },
    {
      path: '/buy-now',
      name: 'buyNow',
      component: BuyNow,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
